// An app's money-back guarantee, shown on the plan and billing pages when the
// app declares one: $config.GUARANTEE = {short, long, question, answer, cancel}.
// Apps without it keep today's wording everywhere.
import config from "@/config";

export function guarantee() {
  const value = config && config.GUARANTEE;
  return value && value.short ? value : null;
}

// The app's refund policy on its own landing page.
export function refundPolicyUrl() {
  const base =
    typeof config.LANDING_PAGE_URL === "string"
      ? config.LANDING_PAGE_URL
      : process.env.VUE_APP_LANDING_PAGE_URL || "https://multisaas.com";
  return base ? base.replace(/\/+$/, "") + "/refund-policy" : "";
}

// Closes the "start a plan" confirmation.
export function checkoutNote() {
  const value = guarantee();
  return value ? "You can cancel anytime. " + value.long : "You can cancel anytime.";
}

// Closes a downgrade confirmation ("...at the new lower price" + this).
export function downgradeNote() {
  return config && config.DOWNGRADE_NOTE
    ? ". " + config.DOWNGRADE_NOTE
    : " - we don't refund the time already paid on your current plan.";
}
